import { render, staticRenderFns } from "./StatePreventionRequest.vue?vue&type=template&id=442584fe&scoped=true"
import script from "./StatePreventionRequest.vue?vue&type=script&lang=js"
export * from "./StatePreventionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442584fe",
  null
  
)

export default component.exports